"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderHouseToMap = exports.getHouseOffset = void 0;
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var rogueItems_sidecar_1 = require("../items/rogueItems-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueRunner_sidecar_1 = require("../scene/rogueRunner-sidecar");
var rogueStats_sidecar_1 = require("../ui/rogueStats-sidecar");
var rogueMaps_1 = require("./rogueMaps");
var rogueMaps_sidecar_1 = require("./rogueMaps-sidecar");
var getHouseOffset = function (house) {
    var ox = Math.floor((rogueDef_sidecar_1.rogueDef.screenWidth - house.w - 1) / 2) + 2;
    var oy = Math.floor((rogueDef_sidecar_1.rogueDef.screenHeight - house.h - 2) / 2);
    return { ox: ox, oy: oy };
};
exports.getHouseOffset = getHouseOffset;
var renderHouseToMap = function (house, map) {
    var _a = (0, exports.getHouseOffset)(house), ox = _a.ox, oy = _a.oy;
    for (var iRoom = 0; iRoom < house.rooms.length; iRoom++) {
        var room = house.rooms[iRoom];
        var colors = [
            rogueDef_sidecar_1.rogueDef.colors.dark,
            // rogueDef.colors.yellow,
            rogueDef_sidecar_1.rogueDef.colors.darkBlue,
            // rogueDef.colors.orange,
            // rogueDef.colors.peach,
        ];
        var floorColor = rando_sidecar_1.rando.sample(colors);
        // Draw floors
        for (var x = room.x; x < room.x + room.w; x++) {
            for (var y = room.y; y < room.y + room.h; y++) {
                rogueMaps_sidecar_1.rogueMaps.setTile(map, x + ox, y + oy, rogueMaps_1.ETile.Floor, floorColor, floorColor, rogueMaps_1.ETileVariant.None, room);
            }
        }
        // Draw walls
        for (var x = room.x - 1; x < room.x + room.w + 1; x++) {
            rogueMaps_sidecar_1.rogueMaps.setTile(map, x + ox, room.y - 1 + oy, rogueMaps_1.ETile.Wall);
            rogueMaps_sidecar_1.rogueMaps.setTile(map, x + ox, room.y + room.h + oy, rogueMaps_1.ETile.Wall);
        }
        for (var y = room.y - 1; y < room.y + room.h + 1; y++) {
            rogueMaps_sidecar_1.rogueMaps.setTile(map, room.x - 1 + ox, y + oy, rogueMaps_1.ETile.Wall);
            rogueMaps_sidecar_1.rogueMaps.setTile(map, room.x + room.w + ox, y + oy, rogueMaps_1.ETile.Wall);
        }
    }
    // Generate doors + windows
    var badMap = false;
    for (var iRoom = 0; iRoom < house.rooms.length; iRoom++) {
        var room = house.rooms[iRoom];
        var walls = [];
        // Find windows and doors
        for (var x = room.x; x < room.x + room.w; x++) {
            walls.push({ x: x + ox, y: room.y - 1 + oy, ox: 0, oy: -1 });
            walls.push({ x: x + ox, y: room.y + room.h + oy, ox: 0, oy: 1 });
        }
        for (var y = room.y; y < room.y + room.h; y++) {
            walls.push({ x: room.x - 1 + ox, y: y + oy, ox: -1, oy: 0 });
            walls.push({ x: room.x + room.w + ox, y: y + oy, ox: 1, oy: 0 });
        }
        var windowsLeft = room.numWindows;
        var internalDoorsLeft = room.numInternalDoors;
        var externalDoorsLeft = room.numExternalDoors;
        var success = false;
        while (walls.length > 0) {
            if (windowsLeft === 0 &&
                internalDoorsLeft === 0 &&
                externalDoorsLeft === 0) {
                success = true;
                break;
            }
            var w = rando_sidecar_1.rando.sampleAndRemove(walls);
            var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, w.x + w.ox, w.y + w.oy);
            var isRotated = w.ox !== 0;
            var variant = isRotated ? rogueMaps_1.ETileVariant.None : rogueMaps_1.ETileVariant.Rotated;
            if (!t) {
                continue;
            }
            if (t.eTile === rogueMaps_1.ETile.Grass) {
                if (externalDoorsLeft > 0) {
                    rogueMaps_sidecar_1.rogueMaps.setTile(map, w.x, w.y, rogueMaps_1.ETile.Door, rogueDef_sidecar_1.rogueDef.colors.dark, rogueDef_sidecar_1.rogueDef.colors.brown, variant);
                    externalDoorsLeft--;
                    continue;
                }
                if (windowsLeft > 0) {
                    rogueMaps_sidecar_1.rogueMaps.setTile(map, w.x, w.y, rogueMaps_1.ETile.Window, rogueDef_sidecar_1.rogueDef.colors.dark, rogueDef_sidecar_1.rogueDef.colors.lightBlue, variant);
                    windowsLeft--;
                    continue;
                }
            }
            if (t.eTile === rogueMaps_1.ETile.Floor) {
                if (internalDoorsLeft > 0) {
                    rogueMaps_sidecar_1.rogueMaps.setTile(map, w.x, w.y, rogueMaps_1.ETile.Door, rogueDef_sidecar_1.rogueDef.colors.dark, rogueDef_sidecar_1.rogueDef.colors.brown, variant);
                    internalDoorsLeft--;
                    continue;
                }
            }
        }
        if (!success) {
            badMap = true; // TODO: redo whole map?
        }
    }
    // TODO: find toilet in space next to wall, not next to door, in bathroom
    // Place furniture
    for (var iRoom = 0; iRoom < house.rooms.length; iRoom++) {
        var room = house.rooms[iRoom];
        var numToiletsLeft = room.numToilets;
        var iAttemptsFurniture = 20;
        while (numToiletsLeft > 0) {
            if (iAttemptsFurniture-- <= 0) {
                badMap = true;
                break;
            }
            //let room = rando.sample(allRooms)
            // Check for doors and wall next to toilet
            var spot = rogueMaps_sidecar_1.rogueMaps.findOpenRoomSpot2(map, room, ox, oy);
            var item = rogueItems_sidecar_1.rogueItems.create('toilet');
            rogueItems_sidecar_1.rogueItems.setPos(item, spot.x, spot.y);
            numToiletsLeft--;
        }
    }
    if (!badMap) {
        // Generate spell points
        var allRooms = house.rooms.map(function (c) { return c; });
        var spellPointsLeft = 3;
        var iAttemptsSpellPoints = 300;
        while (spellPointsLeft > 0) {
            if (iAttemptsSpellPoints-- <= 0) {
                badMap = true;
                break;
            }
            var room = rando_sidecar_1.rando.sample(allRooms);
            var spot = rogueMaps_sidecar_1.rogueMaps.findOpenRoomSpot2(map, room, ox, oy);
            if (spot.found) {
                var item = rogueItems_sidecar_1.rogueItems.create('spell-point');
                rogueItems_sidecar_1.rogueItems.setPos(item, spot.x, spot.y);
                spellPointsLeft--;
            }
        }
    }
    if (!badMap) {
        // Generate items
        //let { ox, oy } = getHouseOffset(house)
        for (var iRoom = 0; iRoom < house.rooms.length; iRoom++) {
            var room = house.rooms[iRoom];
            if (rando_sidecar_1.rando.chance(house.difficulty.roomSpawnItemChance)) {
                var spot = rogueMaps_sidecar_1.rogueMaps.findOpenRoomSpot2(map, room, ox, oy);
                var item = rogueMaps_sidecar_1.rogueMaps.spawnRandomScroll();
                rogueItems_sidecar_1.rogueItems.setPos(item, spot.x, spot.y);
            }
        }
    }
    // Reset fire timer
    rogueStats_sidecar_1.rogueStats.getStats().maxFireTimer = house.difficulty.maxFireTimer;
    rogueStats_sidecar_1.rogueStats.getStats().fireTimer = house.difficulty.maxFireTimer * 2;
    rogueMaps_sidecar_1.rogueMaps.resetVisionToUnseen(map);
    rogueRunner_sidecar_1.rogueRunner.updateVision();
    return !badMap;
};
exports.renderHouseToMap = renderHouseToMap;
